import { Outlet, createBrowserRouter } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { ErrorBoundary } from '../components/ErrorBoundary';
import { CurrentTeamProvider } from '../contexts/CurrentTeamContext';
import { AuthenticatedLayout, RootRedirect } from '../layouts';
import { MainLayout } from '../layouts/MainLayout';
import { Whoami } from '../layouts/Whoami';
import { NotFoundPage } from '../pages/NotFoundPage';
import { UserProfilePage } from '../pages/user/profile';
import { authRoutes } from './auth.routes';
import { teamRoutes } from './team.routes';

// No teams page component
function NoTeamsPage() {
  const theme = useTheme();
  return (
    <div style={{ textAlign: 'center', padding: `${theme.paddingXL}px` }}>
      <h2>No Teams Available</h2>
      <p>
        You are not a member of any teams. Please contact your administrator.
      </p>
    </div>
  );
}

// Authenticated wrapper component
function AuthenticatedWrapper() {
  return (
    <AuthenticatedLayout>
      <CurrentTeamProvider>
        <MainLayout />
      </CurrentTeamProvider>
    </AuthenticatedLayout>
  );
}

// Root component for handling all routes
function RootComponent() {
  return (
    <ErrorBoundary>
      {/* Whoami manages session state globally for all routes */}
      <Whoami />
      <Outlet />
    </ErrorBoundary>
  );
}

// Main router configuration
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootComponent />,
    children: [
      // Unauthenticated routes
      authRoutes,

      // Authenticated routes
      {
        path: '/',
        element: <AuthenticatedWrapper />,
        children: [
          {
            index: true,
            element: <RootRedirect />,
          },
          // Team routes
          teamRoutes,
          // Profile route
          {
            path: 'profile',
            element: <UserProfilePage />,
          },
          // No teams page
          {
            path: 'no-teams',
            element: <NoTeamsPage />,
          },
        ],
      },

      // 404 catch-all
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
